import { Button, Dialog, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import Cookies from "universal-cookie";
import useAddStandard from './useAddStandard';


const cookies = new Cookies();
function DeleteStandard({ open, onClose, type,id,onDelete }) {
    const { setDataToServer } = useAddStandard('/deteleStandardAndClass',onClose)
    const handleDeleteData = (e) => {
        e.preventDefault()
        let data = {type,id}
        setDataToServer.mutate(data)
        onDelete()
    }
    if (!open) return null
    return (
        <>
            <Dialog disableEscapeKeyDown fullWidth={true} maxWidth={'sm'} open={open} onClose={onClose}>
                <div className=' bg-white w-full px-5'>
                    <div className='modal-head flex items-center justify-end'>
                        <div onClick={onClose}>
                            <IconButton>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                    <form className=' space-y-4' onSubmit={handleDeleteData}>
                        <div className=' space-y-7'>
                            <div>
                                <h1 className=' text-2xl text-red-700 font-semibold text-center'>Are You Sure You Want To Delete?</h1>
                            </div>
                        </div>
                        <div className=' space-x-4 text-center pb-5'>
                            <Button type='submit' variant="contained" color={`error`}>Delete</Button>
                            <Button variant="outlined" color='info' onClick={onClose}>Close</Button>
                        </div>
                    </form>
                </div>
            </Dialog>
        </>

    )
}

export default DeleteStandard